import { teamTitleSchema } from 'modules/donor/schemas';
import * as yup from 'yup';

export type TeamTitleFromSchema = {
  title: string;
};

export const teamTitleFormSchema: yup.SchemaOf<TeamTitleFromSchema> =
  yup.object({
    title: teamTitleSchema.required(),
  });
